import { render } from "./LessonsView.vue?vue&type=template&id=6768babf&scoped=true"
import script from "./LessonsView.vue?vue&type=script&lang=js"
export * from "./LessonsView.vue?vue&type=script&lang=js"

import "./LessonsView.vue?vue&type=style&index=0&id=6768babf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6768babf"]])

export default __exports__